import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const ApiFormRecordSelect = ({ options, onChange, disabled }) => {
  const { t } = useTranslation("common");

  return (
    <div className="form-view-select-wrap">
      <label className="form-label" htmlFor="api-form-record">
        {t("Select Record")}
      </label>
      <select
        id="api-form-record"
        name="record"
        className="form-control"
        style={{ maxWidth: 400 }}
        required
        disabled={disabled}
        defaultValue=""
        onChange={(e) => onChange(e.target.value)}>
        <option value="">{t("Select Record")}</option>
        {(options || []).map(([key, label]) => (
          <option key={key} value={key}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

ApiFormRecordSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.array),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

ApiFormRecordSelect.defaultProps = {
  options: [],
  disabled: false
};

export default ApiFormRecordSelect;
